<template>
  <div>
    <Drawer title="新增" width="600" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Card style="margin-top: 5px">
        <Form ref="editForm" :label-width="100" :model="formData">
          <FormItem label="选择站点" prop="company">
            <Select v-model="formData.id" :filterable="true" :disabled="disabled" :remote-method="getOptions">
              <Option value="">请选择</Option>
              <Option v-for="item in companys" :value="item.station_id" :key="item.station_id">{{ item.gas_name }}
              </Option>
            </Select>
          </FormItem>

          <FormItem label="" prop="company">
            <!-- <Select v-model="formData.id" filterable remote :remote-method="getOptions" :loading="loading" required>
                  <Option v-for="item in options" :value="item.station_id" :key="item.value">{{ item.gas_name }}</Option>
                </Select>  -->
            <div style="margin-top: 20px;">
              <Page :total="total" :current.sync="currentPage" @on-change="handlePageChange" />
            </div>
          </FormItem>

          <FormItem label="关联站点" prop="pid">
            <template>
              <div>
                <treeselect :multiple="false" :options="options" v-model="formData.selected" placeholder="请选择父级" />
              </div>
            </template>
          </FormItem>


          <FormItem label="初始余额" prop="company">
            <InputNumber :max="9999999" :min="0.00" v-model="formData.balance" :disabled="disabled" value="0">
            </InputNumber>
          </FormItem>

          <FormItem label="预警金额" prop="warning_money">
            <InputNumber :max="9999999" :min="-9999999" v-model="formData.warning_money" value="0"></InputNumber>
          </FormItem>
          <FormItem label="充值备注" prop="remarks">
            <Input v-model="formData.remarks" maxlength="200" show-word-limit type="textarea" placeholder="" />
          </FormItem>

          <FormItem label="对公信息" prop="corporate">
            <Input v-model="formData.corporate" maxlength="200" aria-rowspan="3" show-word-limit type="textarea" placeholder="" />
          </FormItem>

          <FormItem label="开票信息" prop="bill_info">
            <Input v-model="formData.bill_info" maxlength="200" type="textarea" placeholder="" />
          </FormItem>

          <FormItem label="转款公司" prop="trans_company">
            <Input v-model="formData.trans_company" maxlength="200" type="text" placeholder="" />
          </FormItem>

          <FormItem label = "余额计算方式" prop = "balance_calculate_type">
            <Select v-model="formData.balance_calculate_type">
              <Option value=""> -- </Option>
              <Option value="成本A">成本A</Option>
              <Option value="油机价">油机价</Option>
            </Select>
          </FormItem>

          <FormItem></FormItem>

          <div class="drawer-footer">
            <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
            <Button type="primary" @click="doSubmit">确定</Button>
          </div>
        </Form>
      </Card>



    </Drawer>
  </div>
</template>

<script>
import config from '@/config/base-config'
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: "edit",
  components: { Treeselect },
  props: {
    showEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      apiPath: config.API_PATH,
      formData: {
        type: this.type,
        id: this.id,
        advert_title: '',
        advert_status: '显示',
        balance: 0,
        remarks: '',
        warning_money: 0,
        corporate: '',
        selected: '0', // 或者一个初始选中的数组，例如：[2] 表示选中 id 为 2 的选
        trans_company: '',
        bill_info: '',
        balance_calculate_type: ''
      },
      readOnlys: false,
      options: [
        {
          id: 0,
          label: '无',
        },
      ],
      baseInfo: {},
      proofs: [],
      companys: [],
      changeCompanys: [],
      searchData: {
        mobile: '',
        nick_name: '',
        company_id: '',
        car_number: '',
        create_time: '',
        is_bind: ''
      },
      selectedValue: '',
      loading: false, // 是否正在加载数据
      total: 100, // 总数据量，用于分页
      pageSize: 10, // 每页显示的数据量
      currentPage: 1, // 当前页码
      disabled: false
    }
  },
  methods: {

    async getOptions(query) {
      this.loading = true; // 开始加载数据
      this.formData.query = query;
      if (typeof query === 'object') {
        this.formData.page = query.page;
      }

      //  let res = await this.$commonFun.postProxy('admin/site_balance/getSite',{page:query});
      let res = await this.$commonFun.postProxy('admin/site_balance/getSite', this.formData);
      this.companys = res.data.list
      this.loading = false; // 数据加载完成

    },
    async handlePageChange(page) {
      this.currentPage = page; // 更新当前页码
      this.getOptions({ page: page }); // 重新获取数据以匹配新的页码
    },

    async getFleetDriverCompany() {
      let data = await this.$commonFun.postProxy('admin/site_balance/getSite', {})
      this.$commonFun.dealApiResult(data, () => {
        this.changeCompanys = data.data
        this.showChangeModel = true
      })
    },

    async getInfo() {
      let res = await this.$commonFun.postProxy('admin/site_balance/getSite', this.formData);
      this.companys = res.data.list
      if (this.formData.id != 0) {
        this.formData.balance = res.data.data.balance ? parseFloat(res.data.data.balance) : 0.00
        this.formData.warning_money = res.data.data.warning_money ? parseFloat(res.data.data.warning_money) : 0.00
        this.formData.remarks = res.data.data.remarks ? res.data.data.remarks : ''
        this.formData.corporate = res.data.data.corporate ? res.data.data.corporate : ''
        this.formData.bill_info = res.data.data.bill_info ? res.data.data.bill_info : ''
        this.formData.trans_company = res.data.data.trans_company ? res.data.data.trans_company : ''
        this.formData.balance_calculate_type = res.data.data.balance_calculate_type ? res.data.data.balance_calculate_type : ''
        this.disabled = true
      }
    },

    async getRelatedSite() {
      let res = await this.$commonFun.postProxy('admin/site_balance/getRelatedSite', this.formData);
      this.options = res.data.data;
      this.formData.selected = res.data.selected
    },
    cancelEdit() {
      this.$emit('cancel-edit')
    },
    async doSubmit() {
      let _self = this;
      // this.formData['proofs'] = this.proofs
      // this.formData['id'] = this.id
      let res = await this.$commonFun.postProxy('admin/site_balance/getAdd', this.formData)
      //编辑成功刷新父页面
      this.$commonFun.dealApiResult(res, () => {
        _self.$emit('edit-success')
        _self.$commonFun.successTip(res.msg)
      })
    },
    uploadSuccess(res, file) {
      file.url = res.data.url;
      file.name = res.data.url;
      this.proofs.push(res.data.url)
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.proofs.splice(fileList.indexOf(file), 1)
    },
    uploadError() {
      this.$commonFun.errorTip('上传失败请重试')
    },
    formatError() {
      this.$commonFun.errorTip('图片格式不正确 jpg、jpeg、png')
    },
    exceededSize() {
      this.$commonFun.errorTip('图片大小不能超过2M')
    },
    beforeUpload() {
      if (this.proofs.length > 1) {
        this.$commonFun.errorTip('最多只能上传3张图片')
        return false;
      }
    },
    seeImg(file) {
      this.$Modal.info({
        // title: title,
        width: 800,
        footerHide: true,
        content: `<img src="${file.url}" style="max-width: 500px;max-height: 500px">`
      });
    },
    changeBalanceCalculateType(value) {
      this.formData.balance_calculate_type = value;
    }
  },
  mounted() {
    this.getInfo()
    this.getRelatedSite()
    //  this.getOptions(); // 初始化加载数据
  },
}
</script>

<style scoped lang="less">
.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

.info-item {
  >span:nth-child(1) {
    min-width: 100px;
    display: inline-block;
    text-align: right;
    letter-spacing: 2px;
    padding: 2px;
  }

  >span:nth-child(2) {
    display: inline-block;
    padding-left: 10px;
  }

  .important-word {
    font-weight: bold;
    color: red;
  }
}
</style>
